import React from 'react';
import { DAY_W, BAND_GAP } from './grid-constants';
import { MaintRun } from './band-runs';

interface Props {
  run: MaintRun;
  dayIdx: Map<string, number>;
  windowStart: string;
  windowEnd: string;
  numDays: number;
}

/**
 * A maintenance / OOC window as ONE run-level red-hatch block, label centered
 * once ("Maint" or the notes). Read-only here — removal happens via the cell
 * popover. (This block is pointer-events:none so clicking it falls through to
 * the day-cell layer, which opens the popover showing the block + Remove.)
 */
const VehicleMaintBlock: React.FC<Props> = ({ run, dayIdx, windowStart, windowEnd, numDays }) => {
  const clampIdx = (d: string): number => {
    if (d < windowStart) return 0;
    if (d > windowEnd) return numDays - 1;
    return dayIdx.get(d) ?? 0;
  };
  const sIdx = clampIdx(run.start);
  const eIdx = clampIdx(run.end);
  if (eIdx < sIdx) return null;
  const left = sIdx * DAY_W + BAND_GAP;
  const width = (eIdx - sIdx + 1) * DAY_W - BAND_GAP * 2;

  return (
    <div
      title={run.notes || 'Maintenance / out of commission'}
      aria-label={`Maintenance${run.notes ? ` — ${run.notes}` : ''}`}
      className="absolute inset-y-2 rounded-md px-1 flex items-center justify-center overflow-hidden pointer-events-none
        text-red-50 day:text-red-800 border border-red-400/50 day:border-red-300
        bg-[repeating-linear-gradient(45deg,rgba(120,42,52,0.92)_0,rgba(120,42,52,0.92)_5px,rgba(74,24,32,0.92)_5px,rgba(74,24,32,0.92)_10px)]
        day:bg-[repeating-linear-gradient(45deg,rgba(254,202,202,0.95)_0,rgba(254,202,202,0.95)_5px,rgba(252,165,165,0.95)_5px,rgba(252,165,165,0.95)_10px)]"
      style={{ left, width }}
    >
      <span className="text-[11px] font-semibold leading-tight truncate w-full text-center">
        {run.notes || 'Maint'}
      </span>
    </div>
  );
};

export default VehicleMaintBlock;
